import EmployeesBody from "../features/employees/EmployeesBody";


const EmployeesPage = () => {
    return (
        <>
            <EmployeesBody />
        </>
    )
}

export default EmployeesPage
